"use client";
import * as React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";


function ModernHeroSection() {
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section
      className="relative w-full overflow-hidden pt-[100px] pb-[80px] bg-white font-['Poppins',sans-serif]"
      role="banner"
      aria-label="Hero section"
    >
      {/* Wave Background System - LEFT 65% ONLY */}
      <div className="absolute inset-0 w-full h-full">
        {/* Base Layer */}
        <div
          className="absolute top-0 left-0 h-full w-full bg-gradient-to-br from-[#1719A8] to-[#0F1280]"
          aria-hidden="true"
        />

        {/* Middle Wave Layer */}
        <svg
          className="absolute top-0 left-0 h-full w-full opacity-60"
          viewBox="0 0 650 600"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
          aria-hidden="true"
        >
          <defs>
            <linearGradient id="middleWave" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#FFFFFF" stopOpacity="0.08" />
              <stop offset="50%" stopColor="#FFFFFF" stopOpacity="0.05" />
              <stop offset="100%" stopColor="#FFFFFF" stopOpacity="0.03" />
            </linearGradient>
          </defs>
          <path
            d="M0,0 L650,0 L650,300 C600,350 550,400 500,450 C400,520 300,580 200,590 C100,595 50,590 0,580 Z"
            fill="url(#middleWave)"
          />
        </svg>

        {/* Top Wave Highlight */}
        <svg
          className="absolute top-0 left-0 h-full w-full opacity-20"
          viewBox="0 0 650 600"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
          aria-hidden="true"
        >
          <path
            d="M0,0 L650,0 L650,250 C600,290 550,330 500,370 C400,440 300,500 200,510 C100,515 50,510 0,500 Z"
            fill="#000"
          />
        </svg>
      </div>

      {/* Main Content Container */}
      <div className="relative z-10 mx-auto px-4 max-w-7xl">
        <div className="flex flex-col lg:flex-row items-start gap-[60px]">

          {/* LEFT AREA - 65% */}
          <div
            className={`w-full lg:w-[65%] transition-all duration-700 ease-out ${
              isVisible ? 'translate-y-0 opacity-100' : 'translate-y-5 opacity-0'
            }`}
          >
            {/* H1 - SEO Optimized */}
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-[1.4] text-white mb-6 font-['Poppins',sans-serif]">
              Custom Software Development & Cloud Solutions for Modern Enterprises
            </h1>

            {/* SEO Paragraph */}
            <p className="text-lg font-normal leading-[1.6] text-white/70 mb-8 max-w-[600px] font-['Poppins',sans-serif]">
              Leading software development company specializing in cloud services, IT consulting, and enterprise SaaS solutions. We deliver scalable, secure, and innovative technology solutions that drive business growth and digital transformation.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <button
                onClick={() => navigate("/contact")}
                className="px-8 py-4 text-base font-semibold text-[#1719A8] bg-white border-none rounded-full cursor-pointer transition-all duration-300 font-['Poppins',sans-serif] min-w-[200px] hover:bg-gray-100 hover:-translate-y-0.5"
                aria-label="Get free consultation"
              >
                Book Appointment
              </button>

              <button
                onClick={() => navigate("/consulting")}
                className="px-8 py-4 text-base font-semibold text-white bg-transparent border-2 border-white rounded-full cursor-pointer transition-all duration-300 font-['Poppins',sans-serif] min-w-[200px] hover:bg-white/10"
                aria-label="Explore our services"
              >
                Explore Services
              </button>
            </div>
          </div>

          {/* RIGHT AREA - 35% */}
          <div
            className={`w-full lg:w-[35%] flex justify-center items-center mt-16 lg:mt-0 transition-all duration-700 ease-out delay-200 ${
              isVisible ? 'translate-y-0 opacity-100' : 'translate-y-5 opacity-0'
            }`}
          >
            {/* Hero Image */}
            <div className="relative w-full  max-w-md p-1 bg-white/50 rounded-xl ">
              <img
                src="https://cdn.acsdev.in/Vasta/t1.png"
                alt="Modern technology solutions and software development"
                className="w-full h-auto min-h-[400px] object-contain"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ModernHeroSection;
